export const scheduleLaterToday = "XOb";
export const scheduleThisEvening = "YOb";
export const scheduleTomorrow = "ZOb";
export const scheduleThisWeekend = "_Ob";
export const scheduleNextWeek = "$Ob";
export const scheduleChooseDate = "aPb";
export default {scheduleLaterToday,scheduleThisEvening,scheduleTomorrow,scheduleThisWeekend,scheduleNextWeek,scheduleChooseDate};